export class ShippingAvailabilityLandingFilterVM {
  accountName: any;
  accountNumber: any;
  parentAccountNumber: any;
  itemNumber: any;
  packageSize: any;
  productLine: any;
  productName: any;
  seedSize: any;
  treatment: any;
  state: any;
}
